import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from "@angular/material/dialog";
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-dialog-message',
    templateUrl: './dialog-message.component.html',
    styleUrls: ['./dialog-message.component.scss'],
    imports: [NgClass, MatIcon, MatDialogClose, TranslocoModule]
})
export class DialogMessageComponent {
  data = inject(MAT_DIALOG_DATA);

  titleKey: string;
  descriptionKey: string | string[];
  actionBtnKey: string;
  cancelBtnKey?: string;
  type: 'info' | 'warning' | 'error';

  constructor() {
    const data = this.data;

    this.titleKey = data.titleKey;
    this.descriptionKey = data.descriptionKey;
    this.actionBtnKey = data.actionBtnKey;
    this.cancelBtnKey = data.cancelBtnKey;
    this.type = data.type || 'info';
  }

  get descriptionAsString(): string {
    return typeof this.descriptionKey === 'string' ? this.descriptionKey : '';
  }

  get descriptionAsArray(): string[] {
    return Array.isArray(this.descriptionKey) ? this.descriptionKey : [];
  }

  close(action: 'confirm' | 'cancel') {
    return {action};
  }
}
